DialogEditConfigTipoCtrl.$inject = ['$log', '$scope', '$http', '$timeout', '$rootScope'];
export default function DialogEditConfigTipoCtrl($log, $scope, $http, $timeout, $rootScope) {

    var TAG = 'DialogEditConfigTipoCtrl: ';
    var URL_TIPOS_BASE = Sigo.var.path + '/mantenimiento/tipos-uniges';

    var vm = this;
    vm.hayInspeciones = Sigo.config['inspecciones']['estado_modulo'];

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: false,
        submit: false
    };
    vm.formDeshabilitado = false;
    vm.opcionesSiONo = [
        {label: StringUtils.ucfirst(Lang.choice('nombres.si', 1)), value: 1},
        {label: StringUtils.ucfirst(Lang.choice('nombres.no', 1)), value: 0}
    ];

    vm.prioridades = [
        {label: StringUtils.ucfirst(Lang.choice('nombres.alta', 1)), value: 'alta'},
        {label: StringUtils.ucfirst(Lang.choice('nombres.media', 1)), value: 'media'},
        {label: StringUtils.ucfirst(Lang.choice('nombres.baja', 1)), value: 'baja'}
    ];

    cargarDatos(vm.model.tipoUnidadGestionId);

    vm.editarConfigTipo = function (tipo) {
        var url = URL_TIPOS_BASE + '/edit/' + tipo.id;
        var promesa = $http.post(url, tipo);
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;
        promesa.then(function (data) {
            vm.model = data.data;
            vm.dialogHandler.close(tipo);
        });
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    };

    function cargarDatos(id) {
        vm.cargando.datos = true;
        vm.formDeshabilitado = true;
        var promesa = $http.get(URL_TIPOS_BASE + '/edit-datos/' + id);
        promesa.then(function (data) {
            vm.datos = data.data;
            vm.model = data.data.tipoincidencia;
            vm.cargando.datos = false;
            vm.formDeshabilitado = false;
            $rootScope.$broadcast('datosFormAsignacion', {'data': data.data, 'model': vm.model});

        });
    }

    vm.opcionesEsPublica = [
        {label: 'Si', value: 1},
        {label: 'No', value: 0}
    ];
    vm.opcionesPrioridad = [
        {label: 'Alta', value: 1},
        {label: 'Baixa', value: 0}
    ];
}